import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import {getCustomerOrder, getCustomerOrders, getCustomerProfile, getResourceFile} from '../../network';
import {dateFormatter, formatCurrency, formatPrice} from '../../helpers/Helper';
import {Link, useParams,useHistory} from 'react-router-dom';
import {padding} from '../../utils/formatter';
import LoadingComponent from '../shared/LoadingComponent';

const Layout = styled.div`
    display: grid;
    justify-content: center;
    grid-template-columns: 40rem 22rem;
    grid-template-rows: auto;
    
    margin-top: 5rem;
    margin-bottom: 6rem;

    @media (max-width: 800px){
        display: flex;
        flex-direction: column;
    }
`;

const HeaderContainer = styled.div`
    position:relative;
    img{
        position:absolute;
        bottom:0.2rem;
        height:28rem;
        left:46rem;
    }
    .wave-one{
        background-image: url('/page-decor/product-top-swirl.png');
        background-repeat: no-repeat;
        background-position-x: left;
        background-position-y: top;
        position: absolute;
        width: 100vw;
        height: 57vh;
        bottom: 37%;
        z-index: -1;
    }
    .wave-two{
        background-image: url('/page-decor/product-bottom-swirl.png');
        background-repeat: no-repeat;
        background-position-x: right;
        background-position-y: bottom;
        position: absolute;
        width: 90vw;
        height: 20vh;
        bottom: 25%;
    }

    @media (max-width: 800px){
        img{
            display: none;
        }
    }
`;

const Header = styled.h1`
    margin-bottom: var(--space-56);
        
    font-size: var(--font-40);
    line-height: var(--font-40);
    font-weight: 500;
  
    color: var(--company-dark);

    @media (max-width: 500px){
        font-size: var(--font-32);
    }
`;

const HeaderText = styled.p`
    font-style: normal;
    font-weight: normal;
    
    font-size: var(--font-18);
    line-height: var(--space-28);
    color: var(--color-neutral-gray-800);

    span {
        font-weight: 600;
        color: var(--company-dark);
    }
    
    &:first-of-type {
        margin-bottom: var(--space-24);
    }

    @media (max-width: 500px){
       
    }
`;

const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 8.25rem;
    height: 8.25rem;
    
    background: white;
    
    margin-right: var(--space-32);
    //margin-bottom: var(--space-56);
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 0.5rem;
    
    > img {
        width: 90%;
        height: 90%;
        object-fit: contain;
        padding: 0.25rem;
    }

    @media (max-width: 800px){
        height: 4.25rem;
    }
`;

const OrderLayout = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: auto 10rem 10rem;
    
    margin-top: var(--space-56);
    
    grid-column: 1 / -1;
    
    > p {
        font-style: normal;
        font-weight: 500;
        
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        color: var(--color-gray-500);
    }
    @media (max-width: 500px){
        display: none;
    }
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    
    grid-column: 1 / -1;
    
    margin-top: var(--space-24);
    margin-bottom: var(--space-40);

    background: var(--color-gray-400);
`;

const OrderContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

const LineItemDetailsContainer = styled.div`
    margin-top: 1rem;
    display: grid;
    grid-auto-flow: row;
    
    grid-template-rows: auto 3rem;
`;

const Title = styled.div`
    width: 90%;
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-20);
    line-height: var(--font-28);
    
    color: var(--color-neutral-gray-900);

    @media (max-width: 500px){
        font-size: var(--font-18);
    }
`;

const Brand = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-20);
    
    color: var(--color-neutral-gray-900);
`;

const AttributeSizeRow = styled.span`
  display: flex;
  flex-direction: row;
  
  > span {
    color: var(--color-gray-800);
    
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: normal;
  }
  
  > .divider {
    width: 1px;
    height: var(--space-14);
    
    margin-left: var(--space-16);
    margin-right: var(--space-16);
    
    background: var(--color-gray-300);
  }
`;

const OrderButton = styled.button`
    width: 20rem;
    height: 2.25rem;
    
    padding: var(--space-10);
    
    font-weight: 600;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: white;

    
    background: var(--color-orange-500);
    box-shadow: 0 4px 6px rgba(156, 66, 33, 0.12), 0 2px 4px rgba(237, 137, 54, 0.32);
    transition: background-color 0.3s ease-in;
    border-radius: var(--space-6);
    
    &:hover {
        background: var(--color-orange-400);
    }

    @media (max-width: 500px){
        width: 100%;
        display: flex;
        align-self: center;
    }
`;

const Price = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-20);
    line-height: var(--font-20);
    
    color: var(--color-blue-600);

    @media (max-width: 500px){
        display: flex;
        align-self: center;
    }
`;

const Quantity = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-20);
    line-height: var(--font-20);
    
    color: var(--color-gray-800);

    @media (max-width: 500px){
        font-size: var(--font-18);
    }
`;

const ActionContainer = styled.div`
    display: flex;
    flex-direction: column;
    
    margin-top: var(--space-32);
    
    > span {
        &:first-of-type {
            margin-bottom: var(--space-24);
        }
    }
`;

const OrderConfirmation = ({auth}) => {
    const params = useParams();
    const history = useHistory();
    const [order, setOrder] = useState({});
    const [cart, setCart] = useState([]);
    const [orderTotal, setOrderTotal] = useState(0);
    const [loading,setLoading] = useState(true);
    const [canvasWidth, setCanvasWidth] = useState(0);


    useEffect(() => {
        window.scrollTo(0, 0);
        handleResize();
    });
    const handleResize = () => {
        console.log('resized to: ', window.innerWidth, 'x', window.innerHeight);
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    };


    useEffect(() => {
        const {id: orderId} = params;
        getOrder(auth.customer_id, orderId, auth.token);
    }, []);

    const getOrder = (customerId, orderId, token) => {
        // todo: show error that an invalid order has been entered if fails to load; maybe just redirect to products?

        getCustomerOrder(customerId, orderId, token)
            .then(result => {
                setOrder({...result});
                setCart([...result.variants]);
                setOrderTotal(result.cartTotal);
            })
            .catch(error => console.error(error))
            .finally(() => setLoading(false));
    };

    const retrieveMedia = variant => {
        if (!variant.media) return null;

        let src = null;
        if (variant.media && variant.media.length) {
            for (let i = 0; i < variant.media.length; i++) {
                if (variant.media[i].type === 'image') {
                    src = getResourceFile(variant.media[i].resource);
                    break;
                }
            }
        }

        if (!src) {
            if (variant.product.media && variant.product.media.length) {
                for (let i = 0; i < variant.product.media.length; i++) {
                    if (variant.product.media[i].type === 'image') {
                        src = getResourceFile(variant.product.media[i].resource);
                        break;
                    }
                }
            }
        }

        return src;
    };
    const goBack = () =>{
        history.push("/products");
    }

    return (
        <>
        {loading ?
            <LoadingComponent/>
        :    

            <Layout>
                <HeaderContainer>
                    <div className="wave-one"></div>
                    <div className="wave-two"></div>
                    <img src="/img/confirm_image.jpg" alt="confirmation image"/>
                    <Header>Order Confirmation</Header>
                    <HeaderText>Your order has been placed, for pickup and payment in store.<br/>Your ticket number is <span>#{padding(order.ticket || 0, 8)}</span></HeaderText>
                    <HeaderText>Your ticket number will remain valid for 10 days after receiving this confirmation and will be automatically cancelled thereafter. We’ve also sent an
                        email confirming your order as well as your ticket number. You may cancel your order at any time.</HeaderText>
                </HeaderContainer>
                <div/>
                <OrderLayout>
                    <p>Item</p>
                    <p>Quantity</p>
                    <p style={{justifySelf: 'flex-end'}}>Price</p>
                </OrderLayout>
                {canvasWidth < 500 ?
                    <Title style={{fontWeight:"600",marginTop:"2rem",marginBottom:"2rem"}}>
                        Order Contents
                    </Title>    

                :
                    <Divider/>
                 }
                
                { canvasWidth < 500 ?
                 
                cart.map((lineItem, index) => {
                        return <React.Fragment key={`OrderConfirmationLineItem_${index}`}>
                            <div>
                                <span style={{display:"flex",flexDirection:"row"}}>
                                    {/* <Quantity>{lineItem.quantity}x</Quantity> */}
                                    
                                    <Title>
                                        <span style={{fontWeight:"600"}}>{lineItem.quantity}x</span>{` - `}<span>{lineItem.variant.product.brand.name}</span>{` ${lineItem.variant.product.name}`}{`${lineItem.variant.description ? `, ${lineItem.variant.description}` : ''}`.trim()}
                                        <span>({lineItem.variant.product.attribute_name && lineItem.variant.attribute}, {lineItem.variant.product.size_name && lineItem.variant.size})</span>
                                    </Title>

                                </span>
                                <Divider/>
                            </div>
                        </React.Fragment>
                    })
              
                :
                    cart.map((lineItem, index) => {
                        return <React.Fragment key={`OrderConfirmationLineItem_${index}`}>
                            {(lineItem.variant && lineItem.variant.product) ?
                                <OrderLayout style={{
                                    marginTop: '0',
                                    marginBottom: 'var(--space-56'
                                }}>
                                    <OrderContainer>
                                        <ImageContainer><img src={retrieveMedia(lineItem.variant)}/></ImageContainer>
                                        <LineItemDetailsContainer>
                                            <Title>
                                                <Brand>{lineItem.variant.product.brand.name}</Brand>{` ${lineItem.variant.product.name}`}{`${lineItem.variant.description ? `, ${lineItem.variant.description}` : ''}`.trim()}
                                            </Title>
                                            <AttributeSizeRow>
                                                {(lineItem.variant.product.attribute_name && lineItem.variant.attribute) &&
                                                <span>{lineItem.variant.product.attribute_name}: {lineItem.variant.attribute}</span>}
                                                {(lineItem.variant.product.attribute_name && lineItem.variant.attribute && lineItem.variant.product.size_name && lineItem.variant.size) &&
                                                <div className="divider"/>}
                                                {(lineItem.variant.product.size_name && lineItem.variant.size) &&
                                                <span>{lineItem.variant.product.size_name}: {lineItem.variant.size}</span>}
                                            </AttributeSizeRow>
                                        </LineItemDetailsContainer>
                                    </OrderContainer>
                                    <Quantity>{lineItem.quantity}x</Quantity>
                                    <Price style={{justifySelf: 'flex-end'}}>{formatPrice(lineItem.total)}</Price>
                                </OrderLayout> : null}
                        </React.Fragment>;
                    })
                }
                <ActionContainer>
                    <Price>Order Total: {formatPrice(orderTotal)}</Price>
                    <OrderButton onClick={()=>goBack()}>Return to Products</OrderButton>
                </ActionContainer>
            </Layout>
        }
        </>
    )
};

const mapStateToProps = state => ({auth: state.auth});
export default connect(mapStateToProps)(OrderConfirmation);
